import styled from 'styled-components';

export const PaginationContrplsContainer = styled.div`
  display: flex;
`;
